import DisplayConfigEditor from './editor'

export default [
  { name: 'Program', prop: 'program_id', type: 'autocomplete', references: 'admin/programs', referenceProp: 'name' },
  { name: 'Configuration', prop: 'display_config', type: 'component', component: DisplayConfigEditor }
]
